/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Accordion from 'shared/ui/components/Accordion.vue';
import CheckinTypeOptions from 'ui/components/printing/CheckinTypeOptions.vue';
import ResetEventCheckIns from 'ui/components/printing/ResetEventCheckInsModal.vue';
// Mixins
import checkInMixin from '../../mixins/workspaces/check-in';

const __vue_script__ = {
    name: 'OnsiteScanningSettings',

    components: {
        Accordion,
        CheckinTypeOptions,
    },

    mixins: [checkInMixin],

    props: {
        event: {
            type: Object,
            required: true
        },

        config: {
            type: Object,
            default: () => ({})
        },

        registry: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            fields: [],
            innerValue: {},
            stationTypes: ['attendee', 'host', 'exception']
        };
    },

    async created() {
        try {
            const eid = this.event._id;
            const metadata = await this.$services.metadata.getUserRegistrationFields(eid);
            const fields = metadata
                .filter(m => ['text', 'email', 'choice', 'choice-list', 'boolean', 'number'].includes(m.kind))
                .map(m => ({ value: m.name, label: this.getFieldLabel(m) }));

            this.fields = fields;
        } catch (error) {
            console.error('[OnsiteScanningSettings] Could not load metadata for searching options', error);
        }
    },

    methods: {

        /**
         * handles save button click even if form is invalid
         * @param {boolean} isFormInvalid
         */
        handleClick(isFormInvalid) {
            if (isFormInvalid) {
                this.$emit('invalid');
            }
        },

        save() {
            // We don't want the settings to prune non set values.
            for (const stationType of this.stationTypes) {
                if (!this.innerValue[stationType]) {
                    this.innerValue[stationType] = this.config[stationType];
                }
            }
            this.$emit('valid', this.innerValue);
        },

        /**
         * Sets the settings in the provided scope
         *
         * @param {'attendee'|'host'|'exception'} type a string defining the scope
         * @param {object} data the new data to set in the settings
         */
        setTypeOptions(type, data) {
            console.debug('[OnsiteScanningSettings] New data received', type, data);
            this.innerValue[type] = data;
        },

        resetCheckInData() {
            this.$modal.show(
                ResetEventCheckIns,
                { eid: this.event._id },
                { height: 'auto' },
            );
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
var invalid = ref.invalid;
return [_c('form',{staticClass:"onsite-scanning-settings",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.save)}}},[_c('div',{staticClass:"panels panels-a"},[_c('div',{staticClass:"panel"},[_c('accordion',{attrs:{"headers-i18n-prefix":"onsite_scanning.settings.checkin","default-open-item":"attendee","unlimited-height":true},scopedSlots:_vm._u([_vm._l((_vm.stationTypes),function(stationType){return {key:stationType,fn:function(ref){return [_c('checkin-type-options',{attrs:{"station-type":stationType,"config":_vm.registry[stationType],"value":_vm.config[stationType],"event":_vm.event,"fields":_vm.fields},on:{"input":function (data) { return _vm.setTypeOptions(stationType, data); }}})]}}})],null,true)})],1),_c('div',{staticClass:"panel"},[_c('h3',[_vm._v(_vm._s(_vm.$t('onsite_scanning.actions.title')))]),_c('accordion',{attrs:{"headers-i18n-prefix":"onsite_scanning.actions"},scopedSlots:_vm._u([{key:"reset_event_check_in_data",fn:function(ref){return [_c('p',[_vm._v(_vm._s(_vm.$t('onsite_scanning.actions.reset_event_check_in_data_description')))]),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.resetCheckInData()}}},[_vm._v(_vm._s(_vm.$t('onsite_scanning.actions.reset_check_in_data')))])]}}],null,true)})],1)]),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.handleClick(invalid)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])],1)]}}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "OnsiteScanningSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__